import script from "./ViewPaymentVoucherPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPaymentVoucherPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPaymentVoucherPage.vue?vue&type=style&index=0&id=04efdb29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04efdb29"]])

export default __exports__